var liveAddress = "https://rtl-gen.onrender.com/";

var liveAddress2 = "http://localhost:3000/"
export const SERVER_URL = liveAddress;
export const buyerRole = "buyer";
export const vendorRole = "vendor";
export const defaultRole = buyerRole;


export const urls = {
    signup: SERVER_URL + "signup",
    project: SERVER_URL + "project",
    register: SERVER_URL + "user",
    login: SERVER_URL + "user",
    fileInputs: SERVER_URL + "fileInputs",
    viewInputs: SERVER_URL + "project",
    viewOutputs: SERVER_URL + "project",
    fileOp: SERVER_URL + "fileOp"



};

